import { useSuspenseQuery } from '@tanstack/react-query'

import { GetGruposDeUnidadesDeNegocioDisponiveisService } from '@/http/grupo-unidades-de-negocio.service'
import type { TGruposDeUnidadesDeNegocioDisponiveisResponse } from '@/types/unidade-negocio'
import { UMA_HORA } from '@/utils/constants'
import { regionaisKeys } from '@/utils/regionais-query-keys'

export const useSuspenseRegionais = () => {
  return useSuspenseQuery<TGruposDeUnidadesDeNegocioDisponiveisResponse>({
    queryKey: regionaisKeys.listas(),
    queryFn: () => new GetGruposDeUnidadesDeNegocioDisponiveisService().execute().then((response) => response.data),
    staleTime: UMA_HORA,
  })
}
